import O1HD from "../../../../engines/gameEngine";
import {GHpLocalPropertyInfo, GHpNormData} from "../../../../engines/modules/httpContent/gameHttpContent";
import RankItemNode from "./RankItemNode";

const {ccclass, property} = cc._decorator;

/**
 * 新人榜 Page
 */
@ccclass
export default class PageDonationRank extends cc.Component {

    @property({type:cc.Prefab,displayName:"排行Item预制体"})
    rankItemPrefab : cc.Prefab = null;
    @property({type:cc.ScrollView,displayName:""})
    scrollView : cc.ScrollView = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;

    private mCurrPage : number = 0 ;
    private mTotalPage : number = 0;
    private readonly loadLength : number = 8;

    onLoad () {}

    start () {
        this.scrollView.node.on("scroll-to-bottom", this.scrollBottom , this );
        this.loadData().then();
    }

    async loadData(){
        // 加载远程数据
        let params = { pageNum : this.mCurrPage + 1 , pageSize : this.loadLength };
        O1HD.getModules().gameHttpModule.getRemotePropertyInfo(`api/donation/getDonationList`, params,( res: GHpNormData )=>{
            // @ts-ignore
            this.mCurrPage = res.currPage;
            // @ts-ignore
            this.mTotalPage = res.totalPage;
            // @ts-ignore
            let dataList :RankDonationItemEntity[] = res.list ;
            for ( let i = 1 ; i <= dataList.length ; i ++ ) {
                let rankItemNode = cc.instantiate( this.rankItemPrefab );
                let data = dataList[i-1];
                let mIndex = (this.mCurrPage-1) * this.loadLength + i;
                rankItemNode.getComponent( RankItemNode ).bindData( mIndex , data.uid, data.headImg ,  data.nickName , data.donationCoins , data.donationCoinsType );
                this.contentNode.addChild( rankItemNode );
            }
        },( res: GHpNormData )=>{
            console.error( res.msg );
        });
    }

    /**
     *
     * @param scrollView
     */
    scrollBottom( scrollView : cc.ScrollView){
        if ( this.mCurrPage >= this.mTotalPage ) {
            return;
        }
        this.loadData().then();
    }

}


export interface RankDonationItemEntity{
    uid : string;
    nickName : string;
    headImg : string;
    donationCoins : number;
    donationCoinsType : number;
}
